"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSocialRankingMetricsForInterval = exports.makeSocialRankingsForInterval = exports.SocialRankings = exports.SocialRankingDerivatives = exports.SocialRankingDerivative = exports.SocialRankingSort = exports.SocialPlatformNames = exports.SocialPlatforms = exports.SocialPlatform = exports.SocialRankingMetrics = exports.SocialRankingMetric = exports.SocialRankingIntervals = exports.SocialRankingInterval = void 0;
var SocialRankingInterval;
(function (SocialRankingInterval) {
    SocialRankingInterval["day"] = "day";
    SocialRankingInterval["week"] = "week";
    SocialRankingInterval["month"] = "month";
})(SocialRankingInterval = exports.SocialRankingInterval || (exports.SocialRankingInterval = {}));
exports.SocialRankingIntervals = [
    SocialRankingInterval.day,
    SocialRankingInterval.week,
];
var SocialRankingMetric;
(function (SocialRankingMetric) {
    SocialRankingMetric["followers"] = "followers";
    SocialRankingMetric["totalEngagement"] = "totalEngagement";
    SocialRankingMetric["totalImpressions"] = "totalImpressions";
})(SocialRankingMetric = exports.SocialRankingMetric || (exports.SocialRankingMetric = {}));
exports.SocialRankingMetrics = [
    SocialRankingMetric.followers,
    SocialRankingMetric.totalEngagement,
    SocialRankingMetric.totalImpressions,
];
var SocialPlatform;
(function (SocialPlatform) {
    SocialPlatform["all"] = "all";
    SocialPlatform["facebook"] = "facebook";
    SocialPlatform["instagram"] = "instagram";
    SocialPlatform["linkedin"] = "linkedin";
    SocialPlatform["pinterest"] = "pinterest";
    SocialPlatform["tiktok"] = "tiktok";
    SocialPlatform["twitter"] = "twitter";
    SocialPlatform["youtube"] = "youtube";
})(SocialPlatform = exports.SocialPlatform || (exports.SocialPlatform = {}));
exports.SocialPlatforms = [
    SocialPlatform.facebook,
    SocialPlatform.instagram,
    SocialPlatform.linkedin,
    SocialPlatform.pinterest,
    SocialPlatform.tiktok,
    SocialPlatform.twitter,
    SocialPlatform.youtube,
];
exports.SocialPlatformNames = exports.SocialPlatforms.map(s => s.toString());
var SocialRankingSort;
(function (SocialRankingSort) {
    SocialRankingSort["asc"] = "asc";
    SocialRankingSort["desc"] = "desc";
})(SocialRankingSort = exports.SocialRankingSort || (exports.SocialRankingSort = {}));
var SocialRankingDerivative;
(function (SocialRankingDerivative) {
    SocialRankingDerivative["delta"] = "delta";
    SocialRankingDerivative["percentDelta"] = "percentDelta";
    SocialRankingDerivative["previousValue"] = "previousValue";
    SocialRankingDerivative["currentValue"] = "currentValue";
})(SocialRankingDerivative = exports.SocialRankingDerivative || (exports.SocialRankingDerivative = {}));
exports.SocialRankingDerivatives = [
    SocialRankingDerivative.delta,
    SocialRankingDerivative.percentDelta,
    SocialRankingDerivative.previousValue,
    SocialRankingDerivative.currentValue,
];
exports.SocialRankings = exports.SocialRankingIntervals.flatMap(rankingInterval => [...exports.SocialPlatforms, SocialPlatform.all].flatMap(rankingPlatform => exports.SocialRankingMetrics.flatMap(rankingMetric => exports.SocialRankingDerivatives.map(rankingDeriv => ({ rankingInterval, rankingPlatform, rankingMetric, rankingDeriv })))));
const makeSocialRankingsForInterval = (rankingInterval) => [...exports.SocialPlatforms, SocialPlatform.all].flatMap(rankingPlatform => exports.SocialRankingMetrics.flatMap(rankingMetric => exports.SocialRankingDerivatives.map(rankingDeriv => ({ rankingPlatform, rankingMetric, rankingDeriv }))));
exports.makeSocialRankingsForInterval = makeSocialRankingsForInterval;
const makeSocialRankingMetricsForInterval = (rankingInterval) => [...exports.SocialPlatforms, SocialPlatform.all].flatMap(rankingPlatform => exports.SocialRankingMetrics.map(rankingMetric => ({ rankingInterval, rankingPlatform, rankingMetric })));
exports.makeSocialRankingMetricsForInterval = makeSocialRankingMetricsForInterval;
//# sourceMappingURL=SocialRanking.js.map